import { Box, Image } from '@chakra-ui/react';
import React from 'react';

const Cover = () => (
  <Box width="100%">
    <Box overflow="hidden">
      <Image
        src="https://static.levocdn.com/WGLBUT82/IVCABanneradapts955x400px1-oildrVc2ZuUn.png"
        alt="cover"
        objectFit={{ lg: 'cover' }}
        w="100%"
        h="100%"
        mt="-20px"
        mb="-60px"
        display={{ xs: 'none', md: 'block' }}
      />
      <Image
        src="https://static.levocdn.com/WGLBUT82/IVCABanneradapts955x400px1-oildrVc2ZuUn.png"
        alt="cover"
        w="100%"
        objectFit={{ lg: 'cover' }}
        display={{ base: 'block', md: 'none' }}
      />
    </Box>
  </Box>
);

export default Cover;
